import { jsxs, jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
const progressContainer = "_progressContainer_rnohu_1";
const progressLabel = "_progressLabel_rnohu_8";
const progressElement = "_progressElement_rnohu_17";
const styles = {
  progressContainer,
  progressLabel,
  progressElement
};
const Progress = ({ label, max, value, id, className, ...props }) => /* @__PURE__ */ jsxs("div", { className: clsx(styles.progressContainer, className), ...props, children: [
  /* @__PURE__ */ jsx(
    "progress",
    {
      id,
      max,
      value,
      "aria-labelledby": `${id}-label`,
      "aria-valuenow": value,
      "aria-valuemax": max,
      className: styles.progressElement,
      children: value && `${(value > max ? 100 : value / max * 100).toFixed(2)}%`
    }
  ),
  /* @__PURE__ */ jsx("span", { id: `${id}-label`, className: styles.progressLabel, children: label })
] });
export {
  Progress
};
